module.exports = __webpack_public_path__ + "static/media/benefits-members-es.2f6ff020.svg";